import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usuarioService } from '../services/api';
import '../Auth.css';

function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    dni: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validaciones básicas
    if (!formData.dni || !formData.password) {
      setError('Por favor, completa todos los campos');
      setLoading(false);
      return;
    }

    if (formData.dni.length !== 8) {
      setError('El DNI debe tener 8 dígitos');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      setLoading(false);
      return;
    }

    try {
      // Intentar login con el servicio
      const usuario = await usuarioService.login(formData.dni, formData.password);

      if (!usuario) {
        setError('Credenciales incorrectas');
        setLoading(false);
        return;
      }

      // Login exitoso - Guardar sesión
      localStorage.setItem('usuarioActual', JSON.stringify({
        id: usuario.id,
        dni: usuario.dni,
        nombreCompleto: usuario.nombreCompleto
      }));

      // Redirigir a la página principal
      alert('¡Bienvenido de vuelta!');
      navigate('/');
    } catch (err) {
      console.error('Error en el login:', err);
      
      if (err.message.includes('404') || err.message.includes('no encontrado')) {
        setError('Usuario no encontrado. Verifica tu DNI.');
      } else if (err.message.includes('401') || err.message.includes('incorrecta')) {
        setError('Contraseña incorrecta.');
      } else {
        setError('Error al iniciar sesión. Por favor, intenta de nuevo.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
              <span className="logo-text">Novia de Alquiler</span>
              <span className="logo-brand">"Petit Kano"</span>
            </h1>
            <h2 className="auth-title">Iniciar Sesión</h2>
            <p className="auth-subtitle">Accede a tu cuenta para continuar</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            {error && (
              <div className="auth-error">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="dni">DNI</label>
              <input
                type="text"
                id="dni"
                name="dni"
                value={formData.dni}
                onChange={handleChange}
                placeholder="Ingresa tu DNI (8 dígitos)"
                maxLength="8"
                pattern="[0-9]*"
                className="form-input"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Ingresa tu contraseña"
                className="form-input"
                disabled={loading}
              />
            </div>

            <button 
              type="submit" 
              className="auth-button"
              disabled={loading}
            >
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>

            <div className="auth-footer">
              <p>¿No tienes una cuenta?</p>
              <button 
                type="button"
                onClick={() => navigate('/registro')}
                className="auth-link-button"
                disabled={loading}
              >
                Regístrate aquí
              </button>
            </div>

            <button 
              type="button"
              onClick={() => navigate('/')}
              className="back-home-button"
              disabled={loading}
            >
              ← Volver al inicio
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;














